<template>

  <div class="w-full">

    <CreateOrEditProduct/>

    <div class="flex justify-between w-full">

      <div class="">
        <SelectButton v-model="filter.restaurantPlace"
                      :options="RESTAURANT_PLACES"
                      aria-labelledby="basic"
                      size="small"
                      option-value="value"
                      optionLabel="name"
        />
      </div>
      <Button @click="openProduct(null)" size="small" label="Pridať" icon="pi pi-plus" iconPos="right"/>

    </div>

    <hr class="my-2">

    <div class="w-full flex justify-between items-center">

      <InputText v-model="filter.search" type="text" siz e="small" placeholder="Hladanie"/>

      <div class="flex items-center space-x-2">
        <ToggleButton v-model="filter.active" onLabel="Aktívne" offLabel="Neaktívne" class="py-1.5" size="sm"/>

        <Select v-model="filter.type"
                :options="filterCategoryOptions"
                optionLabel="name"
                optionValue="value"
                placeholder="Kategoria" class="w-full md:w-56"
                :pt="{label: 'py-1'}"
        />
      </div>

    </div>

    <div class="grid grid-cols-4 mt-5 gap-4">

      <SingleProductCard v-for="product in filteredProducts"
                         :product="product"
                         :key="product.id"
                         @edit-product="openProduct"
      />

    </div>
    <!--{{ filter.restaurantPlace}}-->
    <!--    <pre>-->
    <!--      {{ contentStore.appProductsList }}-->
    <!--    </pre>-->
  </div>

</template>

<script setup>
import {computed, reactive, ref, watch} from "vue";
import CreateOrEditProduct, {openProduct} from "@/components/views/CreateOrEditProduct.vue"
import {MASTER_TYPES, RESTAURANT_PLACES} from "@/content/lists.js"
import Supabase from "@/utils/Supabase.js";
import SingleProductCard from "@/components/views/SingleProductCard.vue";
import useContentStore from "@/stores/contentStore.js";

const contentStore = useContentStore()


const filter = reactive({
  restaurantPlace: RESTAURANT_PLACES[0].value,
  type: '-',
  active: true,
  search: ''
})

watch(() => filter.restaurantPlace, async () => {
  filter.search = ''
  filter.type = '-'
})

const filterCategoryOptions = computed(() => [{name: 'Všetko', value: '-'}, ...[
  ...contentStore.appCategories.filter(category => category.restaurantPlace === filter.restaurantPlace).map(category => ({
    name: category.name + ' ' + category.restaurantPlace,
    value: category.id
  }))
]])

const loading = ref(false)
const products = ref([])
const filteredProducts = computed(() => contentStore.appProductsList[filter.restaurantPlace].filter(product => {

  if (filter.type !== '-' && filter.type !== product.categoryId) return false

  const activeMatch = filter.active === product.active
  if (!filter.search || filter.search === '') return activeMatch
  const {title, text} = product
  const search = filter.search.toLowerCase()
  console.log('search', search)
  const text1Match = (text ?? '').toLowerCase().includes(search)
  const text2Match = (title ?? '').toLowerCase().includes(search)
  const text3Match = product?.pluItem?.pluName?.toLowerCase().includes(search)
  return (text1Match || text2Match || text3Match) && activeMatch
}))

</script>